import { ApiCore } from "./utilities/core";

const url = 'process_mining/bpmn';

const apiGenerateBpmnModel = new ApiCore({
    getAll: false,
    getSingle: true,
    post: false,
    postSingle: true,
    put: false,
    patch: true,
    delete: false,
    url: url,
});

export default apiGenerateBpmnModel;